import { useState } from 'react'

import type { UseReactivateAccountModalReturn, ReactivateAccount } from './useReactivateAccountModal.types'

export function useReactivateAccountModal(): UseReactivateAccountModalReturn {
  const [selectedAccount, setSelectedAccount] = useState<ReactivateAccount | undefined>(undefined)

  const openModal = (account: ReactivateAccount) => {
    setSelectedAccount(account)
  }

  const closeModal = () => {
    setSelectedAccount(undefined)
  }

  return {
    selectedAccount,
    isModalOpen: !!selectedAccount,
    openModal,
    closeModal
  }
}
